import { useTranslation } from 'react-i18next';

import { contactFormUrl } from '../app/config';

type StaticSection = {
  title: string;
  paragraphs: string[];
};

function useStaticSections(pageId: 'about' | 'privacy') {
  const { t } = useTranslation();
  return {
    heading: t(`pages.${pageId}.heading`),
    intro: t(`pages.${pageId}.intro`, { defaultValue: '' }),
    sections: t(`pages.${pageId}.sections`, {
      returnObjects: true,
    }) as StaticSection[],
    ctaNote: t('pages.contactNote'),
    ctaLabel: t('pages.contactLinkLabel'),
  };
}

function StaticSectionList({ sections }: { sections: StaticSection[] }) {
  return (
    <>
      {sections.map(section => (
        <div className='static-block' key={section.title}>
          <h3>{section.title}</h3>
          {section.paragraphs.map(paragraph => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      ))}
    </>
  );
}

function StaticContactCta({ note, label }: { note: string; label: string }) {
  return (
    <p className='static-cta'>
      <i className='fas fa-paper-plane' aria-hidden='true' /> {note}{' '}
      <a href={contactFormUrl} target='_blank' rel='noopener noreferrer'>
        {label}
      </a>
    </p>
  );
}

export function AboutPage() {
  const { heading, intro, sections, ctaNote, ctaLabel } =
    useStaticSections('about');

  return (
    <section className='tool-section active static-page'>
      <h2 className='section-title'>
        <i className='fas fa-book-open' aria-hidden='true' />
        {heading}
      </h2>
      {intro ? <p className='static-intro'>{intro}</p> : null}
      <StaticSectionList sections={sections} />
      <StaticContactCta note={ctaNote} label={ctaLabel} />
    </section>
  );
}

export function PrivacyPage() {
  const { heading, intro, sections, ctaNote, ctaLabel } =
    useStaticSections('privacy');
  const { t } = useTranslation();

  return (
    <section className='tool-section active static-page'>
      <h2 className='section-title'>
        <i className='fas fa-user-shield' aria-hidden='true' />
        {heading}
      </h2>
      <p className='static-updated'>{t('pages.privacy.updated')}</p>
      {intro ? <p className='static-intro'>{intro}</p> : null}
      <StaticSectionList sections={sections} />
      <StaticContactCta note={ctaNote} label={ctaLabel} />
    </section>
  );
}
